import { connect } from 'react-redux'
import component from './component'


const mapStateToProps = state => ({
    isEmailSent: state.emailSubscriptionForm.isSent,
    isDisabled: state.items.ids.length === 0
})

export default connect(
    mapStateToProps,
    null
)(component)
